enum PlatformEnum {
	owfe = 'owfe',
	nonIrw = 'non_irw',
	kiosk = 'kiosk'
}

export default PlatformEnum;
